function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M40 41c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z",
  fill: "#EA7125"
}), React.createElement("path", {
  d: "M18.421 64h43.158C66.937 58.447 70 50.818 70 43c0-16.542-13.458-30-30-30S10 26.458 10 43c0 7.82 3.063 15.449 8.421 21zm43.995 2H17.584l-.294-.295C11.386 59.759 8 51.483 8 43c0-17.645 14.355-32 32-32s32 14.355 32 32c0 8.481-3.386 16.757-9.29 22.704l-.294.296z",
  fill: "#A5ACB0"
}), React.createElement("path", {
  d: "M19.2 58.604C15.798 54.075 14 48.68 14 43c0-14.337 11.663-26 26-26s26 11.663 26 26c0 5.678-1.798 11.073-5.198 15.601l-1.6-1.202C62.341 53.221 64 48.241 64 43c0-13.233-10.767-24-24-24S16 29.767 16 43c0 5.243 1.659 10.224 4.8 14.402l-1.6 1.202",
  fill: "#A5ACB0"
}), React.createElement("path", {
  fill: "#A5ACB0",
  d: "M39 60h2v-2h-2zM35 60h2v-2h-2zM43 60h2v-2h-2zM47 60h2v-2h-2zM31 60h2v-2h-2zM15 44h3v-2h-3zM39 21h2v-3h-2zM62 44h3v-2h-3zM24.293 28.707l-3-3 1.414-1.414 3 3-1.414 1.414M55.707 28.707l-1.414-1.414 3-3 1.414 1.414-3 3"
}), React.createElement("path", {
  d: "M31.2 49.603A10.913 10.913 0 0129 43c0-6.065 4.935-11 11-11s11 4.935 11 11a10.92 10.92 0 01-2.199 6.601l-1.6-1.202A8.922 8.922 0 0049 43c0-4.963-4.037-9-9-9s-9 4.037-9 9c0 1.967.622 3.834 1.8 5.401l-1.6 1.202",
  fill: "#EA7125"
}), React.createElement("path", {
  fill: "#EA7125",
  d: "M42.707 41.707l-1.414-1.414 10-10 1.414 1.414-10 10"
}), React.createElement("path", {
  fill: "#A5ACB0",
  d: "M20 70h40v-2H20z"
}), React.createElement("path", {
  d: "M0 0h80v80H0z"
}));

var SvgIconIllustrationMeter = function SvgIconIllustrationMeter(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80"
  }, props), _ref);
};

export default SvgIconIllustrationMeter;